const createEnv = () => {
  
  return /** @type {import('../globals').RaeEnv} */ (Object.keys(window.raeEnv || {}).reduce((obj, key) => {
        return {
            ...obj,
            [key]: window.raeEnv[key],
        };
    }, {}));
  
};

export default createEnv();